// src/utils/buyerNeedPost.js
// Pure, Firebase-free: turns a buyer lead's NEEDS (not the person) into a Feed
// post string. By design it never includes the client's name.

const fmtPrice = (n) => `$${Number(n).toLocaleString("en-US")}`;

const pricePhrase = ({ priceMin, priceMax }) => {
  if (priceMin && priceMax) return `${fmtPrice(priceMin)}–${fmtPrice(priceMax)}`;
  if (priceMax) return `up to ${fmtPrice(priceMax)}`;
  if (priceMin) return `${fmtPrice(priceMin)}+`;
  return "";
};

const TIMELINE_PHRASE = {
  asap: "hoping to buy ASAP",
  "30": "hoping to buy in ~30 days",
  "60": "hoping to buy in ~60 days",
  "90": "hoping to buy in ~90 days",
  "6mo_plus": "buying within 6+ months",
};

export function buildBuyerNeedPost(lead = {}) {
  const beds = lead.bedsMin ? `${lead.bedsMin}+ bd` : "";
  const baths = lead.bathsMin ? `${lead.bathsMin}+ ba` : "";
  const size = [beds, baths].filter(Boolean).join(" / ");

  const types = Array.isArray(lead.propertyTypes)
    ? lead.propertyTypes.filter(Boolean)
    : [];
  const typePhrase = types.length ? types.join(" or ").toLowerCase() : "home";

  const areas = Array.isArray(lead.areas) ? lead.areas.filter(Boolean) : [];
  const areaPhrase = areas.length
    ? ` in ${
        areas.length > 1
          ? `${areas.slice(0, -1).join(", ")}, or ${areas[areas.length - 1]}`
          : areas[0]
      }`
    : "";

  const sentence1 = `🏠 Buyer Need — My client is looking for a${
    size ? ` ${size}` : ""
  } ${typePhrase}${areaPhrase}.`;

  const bits = [];
  const price = pricePhrase(lead);
  if (price) bits.push(`Budget ${price}`);
  if (lead.preApproval === "yes") bits.push("pre-approved");
  else if (lead.preApproval === "in_progress") bits.push("pre-approval in progress");
  if (lead.timeline && TIMELINE_PHRASE[lead.timeline]) {
    bits.push(TIMELINE_PHRASE[lead.timeline]);
  }
  const sentence2 = bits.length ? ` ${bits.join(", ")}.` : "";

  const cta = " Know of anything coming up (incl. pocket listings)? Reach out! #BuyerNeed";

  return `${sentence1}${sentence2}${cta}`.replace(/\s+/g, " ").trim();
}
